/**
 * TBD
 */
export const SHIP_WITH_FAIRE_ENABLED_FROM_COUNTRIES =
  'SHIP_WITH_FAIRE_ENABLED_FROM_COUNTRIES';
